import {LandingPage} from "../models/landing-page.model";
import {Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {map, switchMap} from "rxjs/operators";
import {Globals} from "../../core/globals";
import {ImageHandler} from "../../image-handler.service";
import {TranslationService} from "../../core/services/translation.service";
import {ConfigService} from "../../core/services/config.service";

@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  loadedAll = false;
  landingPages: LandingPage[] = [];

  constructor(
    private http: HttpClient,
    private imageHandler: ImageHandler,
    private translationService: TranslationService,
    private configService: ConfigService
  ) {
  }

  getLandingPages(): Observable<LandingPage[]> {
    // Ist die Widerruf-Funktion abgeschaltet (Vorgabe 'revocation.enabled' != '1'),
    // wird die Unterseite 'revocation' samt ihrer Eigenschaften überall ignoriert
    // (Navigation, Landingpage-Kacheln, getPageOfUrl).
    return this.loadLandingPages().pipe(
      switchMap(pages => this.configService.loadConfig('revocation.enabled').pipe(
        map(config => config?.value === '1'
          ? pages
          : (pages ?? []).filter(page => page?.link !== 'revocation'))
      ))
    );
  }

  private loadLandingPages(): Observable<LandingPage[]> {
    if (this.loadedAll) {
      return of(this.landingPages);
    }
    const landingPages = JSON.parse(localStorage.getItem('landingPages'));
    if (landingPages && landingPages.landingPages?.length > 0) {
      return of(landingPages.landingPages);
    }
    return this.http.get<LandingPage[]>('/webabo/landingpages').pipe(map(landingPages => {
      this.loadedAll = true;
      if (landingPages) {
        landingPages.forEach(page => {
          if (page.viewImg && page.viewFile && page.viewFile.type) {
            page.viewFile = this.imageHandler.addAltText(page.viewFile, page.viewDescription ?? this.translationService.getTranslation('landingPage.viewImage.altText.default'));
          }
          if (page.file && page.file.type) {
            page.file = this.imageHandler.addAltText(page.file, page.description ?? this.translationService.getTranslation('landingPage.image.altText.default'));
          }
          page.isExtern = page.externLink && page.externLink != '';
        })
        this.landingPages = landingPages;
        const expirationDate = new Date();
        expirationDate.setSeconds(expirationDate.getSeconds() + Globals.CACHE_TIME_BASE_DATA);
        localStorage.setItem('landingPages', JSON.stringify({expirationDate, landingPages}));
        return this.landingPages;
      }
    }));
  }

  resetData(): void {
    this.loadedAll = false;
    this.landingPages = [];
  }

  getPageOfUrl(url: string): Observable<LandingPage> {
    if (url) {
      return this.getLandingPages().pipe(map(pages => {
        let foundPage = null;
        pages.forEach(page => {
          if (page && page.link == url) {
            foundPage = page;
            if (!page.isExtern && page.viewImg && page.viewFile && page.viewFile.type) {
              foundPage.viewFile = this.imageHandler.addAltText(page.viewFile, page?.viewDescription ?? this.translationService.getTranslation('landingPage.viewImage.altText.default'));
            }
          }
        });
        return foundPage;
      }));
    } else {
      return of(null);
    }
  }

  isMoveServiceActive(): Observable<boolean> {
    return this.getLandingPages().pipe(map(ps => ps.some(p => /^\/?move$/.test(p.link) && p.active)));
  }
}
